import { render } from "./LoginModal.vue?vue&type=template&id=6d441b1f&scoped=true&ts=true"
import script from "./LoginModal.vue?vue&type=script&lang=ts"
export * from "./LoginModal.vue?vue&type=script&lang=ts"

import "./LoginModal.vue?vue&type=style&index=0&id=6d441b1f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d441b1f"]])

export default __exports__